<template>
  <div class="faq-section">
    <!-- 头部区域 -->
    <div class="header">
      <div class="tag">KNOWLEDGE BASE</div>
      <h2 class="title">Frequently Asked <span class="gradient">Questions</span></h2>

      <!-- 居中带分割线的装饰 -->
      <div class="divider-container">
        <div class="line"></div>
        <span class="square-icon">[■]</span>
        <div class="line"></div>
      </div>
    </div>

    <!-- 两列网格 -->
    <div class="grid">
      <div v-for="(faq, index) in faqs" :key="index" class="faq-card" :class="{ 'open': faq.isOpen }">
        <div class="question" @click="toggleItem(index)">
          <h3>{{ faq.q }}</h3>
          <span class="toggle-icon">{{ faq.isOpen ? '−' : '+' }}</span>
        </div>

        <!-- 答案区域 -->
        <div class="answer" v-show="faq.isOpen">
          <p>{{ faq.a }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqSection',
  data() {
    return {
      faqs: [
        {
          q: 'How does Fraud Counsel recover stolen cryptocurrency?',
          a: 'We combine blockchain forensic technology, transaction tracing, and legal recovery strategies to track and reclaim stolen or inaccessible digital assets. Our expert investigators work closely with international cybercrime units, exchanges, and compliance networks to locate your funds and assist in the secure recovery process.',
          isOpen: true // 默认第一项展开
        },
        {
          q: 'Can you guarantee full recovery of my funds?',
          a: 'No legitimate firm can guarantee recovery due to the anonymous nature of blockchain. However, we provide the highest possible success rates and keep you informed at every step.',
          isOpen: false
        },
        {
          q: 'What types of fraud and scams do you handle?',
          a: 'We handle crypto investment scams, romance scams (pig butchering), phishing attacks, rug pulls, exchange hacks, NFT fraud, and more.',
          isOpen: false
        },
        {
          q: 'How long does the recovery process take?',
          a: 'Timelines vary based on the complexity of the case. Simple cases may take weeks, while complex cross-border tracing can take several months.',
          isOpen: false
        },
        {
          q: 'Is my information kept confidential?',
          a: 'Absolutely. All case data, communications, and evidence are encrypted and handled under the highest data-protection standards.',
          isOpen: false
        },
        {
          q: 'Do you work with law enforcement agencies?',
          a: 'Yes. We work directly with international law enforcement and cybercrime units to build cases and achieve recovery outcomes.',
          isOpen: false
        },
        {
          q: 'What information do I need to start a case?',
          a: 'You will typically need your wallet address, transaction hashes (TXIDs), and any communication records with the scammers.',
          isOpen: false
        },
        {
          q: 'Which cryptocurrencies and networks do you trace?',
          a: 'We support tracing across major networks including Bitcoin, Ethereum, BNB Chain, Tron, Solana, and all EVM-compatible chains.',
          isOpen: false
        }
      ]
    };
  },
  methods: {
    toggleItem(index) {
      this.faqs[index].isOpen = !this.faqs[index].isOpen;
    }
  }
}
</script>

<style scoped>
.faq-section {
  background-color: #070b14;
  padding: 100px 5%;
  color: #fff;
}

/* 头部区域 */
.header {
  max-width: 1400px;
  margin: 0 auto 60px;
  text-align: left;
}

.tag {
  color: #00ff88;
  font-size: 0.85rem;
  letter-spacing: 2px;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-weight: 600;
}

.title {
  font-size: 3.5rem;
  font-weight: 800;
  margin: 0 0 20px;
}

/* 渐变文字效果 */
.gradient {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
}

/* 分割线 */
.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
}

.divider-container .square-icon {
  color: #00ff88;
  font-size: 0.9rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 两列网格布局 */
.grid {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

/* 卡片样式 */
.faq-card {
  background: #0a101f;
  border: 1px solid #253045;
  border-radius: 8px;
  padding: 25px 30px;
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 80px;
}

/* 展开状态：边框变绿 */
.faq-card.open {
  border: 1px solid #00ff88;
  box-shadow: 0 0 20px rgba(0, 255, 136, 0.1);
}

/* 问题行 */
.question {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.question h3 {
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0;
}

.toggle-icon {
  font-size: 1.5rem;
  color: #fff;
  font-weight: 300;
  user-select: none;
}

/* 答案区域 */
.answer {
  margin-top: 20px;
  border-top: 1px solid rgba(37, 48, 69, 0.5);
  padding-top: 20px;
}

.answer p {
  color: #a0b3cc;
  font-size: 1.05rem;
  line-height: 1.8;
  margin: 0;
}

/* 响应式适配 */
@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
    /* 中屏及以下变为单列 */
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.5rem;
  }

  .question h3 {
    font-size: 1.1rem;
  }
}
</style>